import { Property, PropertyType } from '@arrived/models';

import { Constants } from '../constants';

export const getPropertyPrimaryPhoto = (property: Property, defaultPhoto?: string | undefined): string => {
  if (property == null) {
    if (!defaultPhoto) {
      return Constants.defaultPropertyImageUrl;
    }

    return defaultPhoto;
  }

  if (property.photos != null && property.photos.length > 0) {
    return property.photos[0].url;
  }

  if (!defaultPhoto) {
    return Constants.defaultPropertyImageUrl;
  }

  return defaultPhoto;
};

export const hasRentBack = (property: Property): boolean => {
  return property.rentbackPercent != null && property.rentbackPercent > 0;
};

export const formatPropertyType = (propertyType: string | undefined | null) => {
  if (!propertyType) {
    return 'N/A';
  }
  switch (propertyType) {
    case PropertyType.SINGLE_FAMILY_HOME:
      return 'Single Family Home';
    case PropertyType.MULTI_FAMILY_HOME:
      return 'Multi Family Home';
    case PropertyType.APARTMENT:
      return 'Apartment';
    default:
      return 'N/A';
  }
};

export const getBathroomCount = (property: Property): number => {
  return Number((property.fullBathrooms || 0) + (property.halfBathrooms || 0) / 2.0);
};
